import { Distance } from 'common/utils';

export const getHereRouteDistance = (sections: any): Distance => {
  const distance = Math
    .round(sections.reduce((acc: number, { travelSummary: { length } }: any) => (length ? acc + length : acc), 0) / 1000);

  return distance.toString(); // km.
}
